<div
  class="rv-rows small"
  *ngLet="{
    filterChangeTrigger: filterChange | async,
    operatorOptions: operatorOptions | async,
    selectedOperator: selectedOperator | async,
    to: queryTo | async,
    from: queryFrom | async
  } as vm"
>
  <!--
    Note: filterChangeTrigger, despite seemingly being unused in the component, is required for the filter to work. Do not remove it
  -->
  <select-dropdown
    [options]="vm.operatorOptions"
    [selectedOptionId]="vm.selectedOperator"
    (selectedOptionIdChange)="operatorChange.next($event)"
  ></select-dropdown>
  <deprecated-text-field
    *ngIf="showFrom(vm.selectedOperator)"
    name="from"
    [ngModel]="reverseParse(vm.from)"
    (ngModelChange)="fromChange.next($event)"
    [required]="true"
  ></deprecated-text-field>
  <div *ngIf="showTo(vm.selectedOperator)" class="combiner rv-low-contrast">
    and
  </div>
  <deprecated-text-field
    *ngIf="showTo(vm.selectedOperator)"
    name="to"
    [ngModel]="reverseParse(vm.to)"
    (ngModelChange)="toChange.next($event)"
    [required]="true"
  ></deprecated-text-field>
</div>
